import { useEffect, useState } from "react";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

// Higher-priced groups: salla (venues/restaurants) and muzike (music).
export const DEFAULT_PLANS = {
  foundingLimit: 10,
  // Founding prices — live for the first N businesses.
  prices: {
    default: { basic: 4.99, premium: 9.99 },
    salla: { basic: 9.99, premium: 19.99 },
    muzike: { basic: 9.99, premium: 19.99 },
  },
  // Standard prices — auto-applied once founding spots fill. Editable in admin.
  standardPrices: {
    default: { basic: 9.99, premium: 19.99 },
    salla: { basic: 19.99, premium: 39.99 },
    muzike: { basic: 19.99, premium: 39.99 },
  },
};

export const PLAN_LIMITS = {
  basic: { photos: 5, desc: 300, video: false, instagram: false, website: false, extraCategories: 0 },
  premium: { photos: 20, desc: 1000, video: true, instagram: true, website: true, extraCategories: 2 },
};

export const isPremium = (v) => (v && v.tier) === "premium";
export const planLimit = (tier) => PLAN_LIMITS[tier === "premium" ? "premium" : "basic"];

// Price for a category + tier. `founding` selects which price set to use.
export const priceFor = (settings, categoryId, tier, founding = true) => {
  const s = settings || DEFAULT_PLANS;
  const set = founding ? s.prices : s.standardPrices || s.prices;
  const group = set[categoryId] || set.default;
  const val = group[tier];
  return val != null ? val : set.default[tier];
};

export const fmtPrice = (n) => `€${(Math.round(Number(n) * 100) / 100).toString()}`;

export default function usePlanSettings() {
  const [settings, setSettings] = useState(DEFAULT_PLANS);
  const [count, setCount] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(doc(db, "settings", "plans"));
        if (snap.exists()) {
          const d = snap.data();
          setSettings({
            foundingLimit: d.foundingLimit ?? DEFAULT_PLANS.foundingLimit,
            prices: { ...DEFAULT_PLANS.prices, ...(d.prices || {}) },
            standardPrices: { ...DEFAULT_PLANS.standardPrices, ...(d.standardPrices || {}) },
          });
        }
      } catch (err) {
        console.warn("Plan settings fallback:", err.message);
      }
      try {
        const vs = await getDocs(collection(db, "vendors"));
        setCount(vs.size);
      } catch {}
      setLoaded(true);
    })();
  }, []);

  const founding = count < (settings.foundingLimit || 0);
  return { settings, loaded, founding, count };
}
